/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DisableWebhookGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type DisableWebhookRequest = {
  webhookID: string;
};

export type DisableWebhookResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableWebhookGlobals$inboundSchema: z.ZodType<
  DisableWebhookGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type DisableWebhookGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const DisableWebhookGlobals$outboundSchema: z.ZodType<
  DisableWebhookGlobals$Outbound,
  z.ZodTypeDef,
  DisableWebhookGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function disableWebhookGlobalsToJSON(
  disableWebhookGlobals: DisableWebhookGlobals,
): string {
  return JSON.stringify(
    DisableWebhookGlobals$outboundSchema.parse(disableWebhookGlobals),
  );
}
export function disableWebhookGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<DisableWebhookGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableWebhookGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableWebhookGlobals' from JSON`,
  );
}

/** @internal */
export const DisableWebhookRequest$inboundSchema: z.ZodType<
  DisableWebhookRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  webhookID: z.string(),
});
/** @internal */
export type DisableWebhookRequest$Outbound = {
  webhookID: string;
};

/** @internal */
export const DisableWebhookRequest$outboundSchema: z.ZodType<
  DisableWebhookRequest$Outbound,
  z.ZodTypeDef,
  DisableWebhookRequest
> = z.object({
  webhookID: z.string(),
});

export function disableWebhookRequestToJSON(
  disableWebhookRequest: DisableWebhookRequest,
): string {
  return JSON.stringify(
    DisableWebhookRequest$outboundSchema.parse(disableWebhookRequest),
  );
}
export function disableWebhookRequestFromJSON(
  jsonString: string,
): SafeParseResult<DisableWebhookRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableWebhookRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableWebhookRequest' from JSON`,
  );
}

/** @internal */
export const DisableWebhookResponse$inboundSchema: z.ZodType<
  DisableWebhookResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
  });
});
/** @internal */
export type DisableWebhookResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
};

/** @internal */
export const DisableWebhookResponse$outboundSchema: z.ZodType<
  DisableWebhookResponse$Outbound,
  z.ZodTypeDef,
  DisableWebhookResponse
> = z.object({
  headers: z.record(z.array(z.string())),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
  });
});

export function disableWebhookResponseToJSON(
  disableWebhookResponse: DisableWebhookResponse,
): string {
  return JSON.stringify(
    DisableWebhookResponse$outboundSchema.parse(disableWebhookResponse),
  );
}
export function disableWebhookResponseFromJSON(
  jsonString: string,
): SafeParseResult<DisableWebhookResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DisableWebhookResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DisableWebhookResponse' from JSON`,
  );
}
